import { HStack, Text, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Button, View } from 'native-base';
import React from 'react';

import { SplitInput } from '../CustomerOffers/components/SplitInput';

interface ValidateTokenProps {
  inputProps: {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    isError: boolean;
    loadingToken: boolean;
  };
  handleValidateToken: (value: string) => void;
}
export const ContainerMobile: React.FC<ValidateTokenProps> = ({
  inputProps,
  handleValidateToken,
}) => {
  const allInputsFilled = inputProps.value?.toString().length === 6;

  return (
    <View minW="container">
      <VStack p="inline.xxxs" flex={1}>
        <VStack space="inline.xxs" flex={1} justifyContent={'center'}>
          <Text fontSize={Typography['fontsize.xl']} variant="semibold" textAlign="center">
            Insira seu token
          </Text>
          <Text fontSize={Typography['fontsize.md']} variant={'regular'}>
            Informe abaixo o token que enviamos para o seu WhatsApp.
          </Text>
          <HStack>
            <SplitInput {...inputProps} />
          </HStack>
          <Text fontSize={Typography['fontsize.md']} variant={'regular'} pb="inline.md">
            Caso não tenha recebido um token entre em contato com seu(sua) assessor(a).
          </Text>
        </VStack>
        <Button
          variant="primary"
          isLoading={inputProps.loadingToken}
          spinnerPlacement="end"
          isLoadingText="Validando..."
          mb="inline.nano"
          isDisabled={inputProps.isError || !allInputsFilled || inputProps.loadingToken}
          onPress={() => handleValidateToken(inputProps.value)}
          p="inline.nano"
          minH="inline.sm"
          bg="brand.tertiary.principal"
          borderRadius="100px"
          w={{ base: 'full', sm: 'container' }}
          _text={{
            textTransform: 'uppercase',
            fontFamily: Typography['fontfamily.base.semibold'],
            fontSize: Typography['fontsize.md'],
          }}>
          Verificar token
        </Button>
      </VStack>
    </View>
  );
};
